import { ResponseCode } from '@/common/request/types';
import { useAppRouter } from '@/common/route/useAppRouter';
import { validateDateAfter, validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_HOMEPAGE } from '@/modules/main/router';
import { bonusService } from '@/services/bonus';
import { useVuelidate } from '@vuelidate/core';
import { required } from '@vuelidate/validators';
import { reactive } from 'vue';

export function useBonusBoost() {
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        isNew: true,
        routineValue: '',
        newPlayerValue: '',
        running: false,
        startTime: new Date(),
        endTime: new Date()
    });

    const validations = {
        routineValue: { required, format: validateFormat(/^\d+(,\d+)*$/) },
        newPlayerValue: { required, format: validateFormat(/^\d+(,\d+)*$/) },
        startTime: { required, validateDate: validateDateAfter() },
        endTime: { required, validateDate: validateDateAfter('startTime') }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: bonusService.boost.get,
        onSuccess: ({ data }) => {
            model.isNew = false;
            data.startTime = new Date(data.startTime);
            data.endTime = new Date(data.endTime);
            Object.assign(model, data);
        },
        onError: ({ code }) => {
            if (code === ResponseCode.NothingFound) {
                model.isNew = true;
                model.routineValue = '';
                model.newPlayerValue = '';
                model.running = false;
                model.startTime = new Date();
                model.endTime = new Date();
            } else router.push({ name: ROUTE_NAME_HOMEPAGE });
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                bonusService.boost.update(
                    model.routineValue,
                    model.newPlayerValue,
                    model.startTime.getTime(),
                    model.endTime.getTime()
                ),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: bonusService.boost.remove,
            onSuccess: fetch,
            onFinally: () => v$.value.$reset()
        })
    };

    return { model, v$, fetch, actions };
}
